import React from "react"

const HelpTooltip = ({ children, content }) => {
  return (
    <span
      className={`help-tooltip ${children ? "help-tooltip--inline" : ""}`}
      tabIndex={0}
      aria-label="More information"
    >
      {children ? (
        <span className="help-tooltip__trigger">{children}</span>
      ) : (
        <span className="help-tooltip__icon" aria-hidden="true">
          ?
        </span>
      )}
      <span className="help-tooltip__content">{content || children}</span>
    </span>
  )
}

export default HelpTooltip
